import { Button, Stack, SxProps, Theme, Typography } from '@mui/material';
import { MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

import type { LocalCartItem, Ticket } from 'restful/tickets';
import { TicketStatusFragment } from 'types/api/dato-operations.types';

import TicketItemRow from './TicketItemRow';

interface TicketSeatingActionProps {
  quantity: number;
  onSelectSeats: MouseEventHandler<HTMLButtonElement>;
  sx?: SxProps<Theme>;
}

export const TicketSeatingAction = ({
  quantity,
  onSelectSeats,
  sx,
}: TicketSeatingActionProps) => {
  const hasSeats = quantity > 0;

  return (
    <Stack
      sx={[
        {
          alignItems: 'flex-end',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {hasSeats && (
        <Typography variant="extraSmall">
          <FormattedMessage
            id="event.seating.selected"
            values={{ amount: quantity }}
          />
        </Typography>
      )}
      <Button
        variant="text"
        onClick={onSelectSeats}
        sx={{
          whiteSpace: 'nowrap',
          color: hasSeats ? 'grey.200' : 'grey.400',
        }}
      >
        {hasSeats ? (
          <FormattedMessage id="event.seating.change_seats" />
        ) : (
          <FormattedMessage id="event.seating.select_seats" />
        )}
      </Button>
    </Stack>
  );
};

interface Props {
  ticket: Ticket;
  status?: TicketStatusFragment;
  cartItem: LocalCartItem | undefined;
  onSelectSeats: (ticket: Ticket) => void;
  onOpenDetail: (ticket: Ticket) => void;
}

const TicketSeatingItem = ({
  ticket,
  status,
  cartItem,
  onSelectSeats,
  onOpenDetail,
}: Props) => {
  const handleSelectSeats: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onSelectSeats(ticket);
  };

  return (
    <TicketItemRow ticket={ticket} status={status} onOpenDetail={onOpenDetail}>
      <TicketSeatingAction
        quantity={cartItem?.quantity ?? 0}
        onSelectSeats={handleSelectSeats}
      />
    </TicketItemRow>
  );
};

export default TicketSeatingItem;
